import React, { useState, useEffect } from 'react';
import { Howl, Howler } from 'howler';
import { useMediaSession } from '@mebtte/react-media-session';
import { HAS_MEDIA_SESSION } from '@mebtte/react-media-session';

import { subscribe, unsubscribe } from './../../lib/events';
import { getUniqueId } from '../../lib/unique_id';

import { TrackInfo } from './TrackInfo.jsx';
import { PlayerControl } from './PlayerControl.jsx';
import { VolumeControl } from './VolumeControl.jsx';
import { PlayListToggle } from './PlayListToggle.jsx';
import { PlayerShopLink } from './PlayerShopLink.jsx';


export const Player = () => {
    const [ volume, setVolume ] = useState(50);
    const [ isPlaying, setIsPlaying ] = useState(false);
    const [ playlistIsOpen, setPlaylistIsOpen ] = useState(false);
    const [ audioPlayer, setAudioPlayer ] = useState(false);
    const [ audioDuration, setAudioDuration ] = useState(0);
    const [ audioPlayerIsLoading, setAudioPlayerIsLoading] = useState(false);

    const [ playlist, setPlaylist ] = useState([]);
    const [ currentTrack, setCurrentTrack ] = useState(false);
    const [ playlistPosition, setPlaylistPosition ] = useState(-1);

    const findPlaylistPosition = () => {
        if(playlist && currentTrack){
            return playlist.findIndex(item => (item.id == currentTrack.id));
        } else {
            return false;
        }
    }

    /*useMediaSession({
        title: currentTrack?.title,
        artist: currentTrack?.artist,
        onPlay: handlePlayPause,
        onPause: handlePlayPause,
        onPreviousTrack : handlePrevTrack,
        onNextTrack: handleNextTrack,
    });*/

    //add item(s) to end of playlist
    // add_option:
    // 'cue' => add items to end of playlist
    // 'play' => add items to beginning of playlist & play first track
    const addTracks = (newTracks, add_option) => {
        //add unique id for playlist id
        let unique_id = getUniqueId();
        newTracks = newTracks.map( item => ({ ...item, id : unique_id + item.catNo + item.trackNo + item.title }) );

        if(add_option == 'cue'){
            setPlaylist(oldTracks => oldTracks.concat(newTracks));
        }
        if(add_option == 'play'){
            setPlaylist(oldTracks => newTracks.concat(oldTracks));
            setCurrentTrack(newTracks[0]);
        }
    }

    useEffect(() => {
        if(currentTrack){
            if(audioPlayer){
                audioPlayer.unload();
            }
            let newPlayer = false;
            setAudioPlayerIsLoading(true);
            newPlayer = new Howl({
                src: [currentTrack.soundUri],
                volume: volume / 100,
                html5: true,
                onload: function() {
                    setAudioDuration(newPlayer.duration());
                    newPlayer.play();
                    setIsPlaying(true);
                    setPlaylistPosition(findPlaylistPosition());
                    setAudioPlayerIsLoading(false);
                },
                onend: function() {
                    setCurrentTrack(playlist[findPlaylistPosition() + 1])
                }
            });
            setAudioPlayer(newPlayer);
        } else {
            if(audioPlayer){
                audioPlayer.unload();
            }
            setAudioPlayer(false);
        }

        return function cleanup() {
            if(audioPlayer){
                audioPlayer.unload();
            }
            setAudioPlayer(false);
        };
    }, [currentTrack]);

    useEffect(() => {
        subscribe("playlist:add", (data) => {
                addTracks(data.detail.tracks, data.detail.option);
            }
        );
        return () => {
            unsubscribe("playlist:add");
        }
    }, []);

    useEffect(() => {
        if(audioPlayer){
            audioPlayer.volume(volume/100);
        }
    }, [volume]);

    useEffect(() => {
        if(playlist.length > 0){
            setPlaylistIsOpen(true);
        }
    }, [playlist]);

    const handlePlayPause = () => {
        if(audioPlayer){
            setIsPlaying(prevIsPlaying => !prevIsPlaying);
            if(isPlaying){
                audioPlayer.pause();
            } else {
                audioPlayer.play();
            }
        } else {
            if(playlist.length > 1){
                setCurrentTrack(playlist[0]);
            }
        }
    }

    const handleNextTrack = () => {
        if((playlist.length > 0) && (playlistPosition < playlist.length - 1)){
            setCurrentTrack(playlist[playlistPosition + 1]);
        }
    }

    const handlePrevTrack = () => {
        if((playlist.length > 0) && (playlistPosition > 0)){
            setCurrentTrack(playlist[playlistPosition - 1]);
        }
    }

    const handleVolumeDown = () => {
        if(volume > 0){
            setVolume(prevVolume => prevVolume - 1);
        }
    }

    const handleVolumeUp = () => {
        if(volume < 100) {
            setVolume(prevVolume => prevVolume + 1)
        }
    }

    const handleVolumeClick = (event) => {
        let volumePercentage = parseInt((event.nativeEvent.offsetX / event.target.clientWidth) * 100);
        setVolume(volumePercentage);
    }

    const onPlaylistToggle = (event) => {
        setPlaylistIsOpen(prevPlaylistIsOpen=> !prevPlaylistIsOpen);
    }

    const handlePlaylistTrackClick  = (track) => {
        setCurrentTrack(track);
    }

    return (
        <div className="player">
            <div className="inner">
                <div className="upper">
                    <div className="player-icon"></div>
                    <TrackInfo audioDuration={audioDuration} isPlaying={isPlaying} track={currentTrack} audioPlayer={audioPlayer} audioPlayerIsLoading={audioPlayerIsLoading}></TrackInfo>
                    <PlayListToggle playlist={playlist} playlistPosition={playlistPosition} playlistIsOpen={playlistIsOpen} onPlaylistToggle={onPlaylistToggle} onTrackClick={handlePlaylistTrackClick} audioPlayerIsLoading={audioPlayerIsLoading}></PlayListToggle>
                </div>
                <div className="lower">
                    <PlayerControl isPlaying={isPlaying} onPlayPause={handlePlayPause} onNextTrack={handleNextTrack} onPrevTrack={handlePrevTrack}></PlayerControl>
                    <VolumeControl volume={volume} onVolumeDown={handleVolumeDown} onVolumeUp={handleVolumeUp} onVolumeClick={handleVolumeClick}></VolumeControl>
                    <PlayListToggle playlist={playlist} playlistPosition={playlistPosition} playlistIsOpen={playlistIsOpen} onPlaylistToggle={onPlaylistToggle} onTrackClick={handlePlaylistTrackClick} audioPlayerIsLoading={audioPlayerIsLoading}></PlayListToggle>
                    <PlayerShopLink track={currentTrack}></PlayerShopLink>
                </div>
            </div>
        </div>
    );
}